/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Channel } from '@wit/vtv-x-foundation-lib';
import React, { Suspense } from 'react';

const ChannelCard = React.lazy(() => import('./ChannelCard'));

interface Props {
  data: Channel[];
  onChannelClick?: (channel: Channel) => void;
}

function getChannelsListElement({ data, onChannelClick }: Props): JSX.Element[] {
  return data.map((channel) => (
    <div className="channel-container" key={`${channel.channelID}-${channel.channelNumber}`}>
      <ChannelCard channel={channel} onClick={onChannelClick} />
    </div>
  ));
}

export default function ChannelsGrid({ data, onChannelClick }: Props): JSX.Element {
  return (
    <div className="channels-grid-wrapper">
      <div className="channels-grid-container" id="ChannelsGrid">
        <Suspense fallback={<></>}>{getChannelsListElement({ data, onChannelClick })}</Suspense>
      </div>
    </div>
  );
}
